"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var react_router_1 = require("react-router");
var ApolloClient_1 = require("src/ApolloClient");
var ErrorBoundary_1 = require("src/ErrorBoundary");
/**
 * Mutation that submits user credentials and retrieves a token
 */
exports.confirmEmailMutation = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nmutation ConfirmEmailMutation($confirmationToken: String!) {\n  confirmEmail(confirmationToken: $confirmationToken) {\n    success\n    confirmationTokenError\n    emailError\n  }\n}\n"], ["\nmutation ConfirmEmailMutation($confirmationToken: String!) {\n  confirmEmail(confirmationToken: $confirmationToken) {\n    success\n    confirmationTokenError\n    emailError\n  }\n}\n"])));
/**
 * Connects the ConfirmEmail form the the graphql Mutations
 */
var ConfirmationPage = /** @class */ (function (_super) {
    __extends(ConfirmationPage, _super);
    function ConfirmationPage(props) {
        var _this = _super.call(this, props) || this;
        var params = new URLSearchParams(_this.props.location.search);
        var confirmationToken = params.get('confirmation_token');
        if (!confirmationToken) {
            _this.props.displayMessage('Can\'t confirm account without token.', 'error');
            _this.props.history.push('/');
            return _this;
        }
        ApolloClient_1.apolloClient.mutate({
            mutation: exports.confirmEmailMutation,
            variables: { confirmationToken: confirmationToken }
        }).then(function (result) {
            var error = result.errors && result.errors[0];
            if (error) {
                _this.props.displayMessage(error.message, 'error');
            }
            if (!result.data) {
                _this.props.displayMessage('Response empty when trying to confirm email.', 'error');
                return;
            }
            var data = result.data;
            if (data.confirmEmail.success) {
                _this.props.displayMessage('Account Confirmed..', 'success');
                _this.props.history.push('/logIn/');
            }
            else {
                var confirmationError = data.confirmEmail.confirmationTokenError ||
                    data.confirmEmail.emailError ||
                    'Unable to confirm Account';
                _this.props.displayMessage(confirmationError, 'error');
                _this.props.history.push('/');
            }
        }).catch(function (error) {
            _this.props.displayMessage(error.message, 'error');
            _this.props.history.push('/');
        });
        return _this;
    }
    ConfirmationPage.prototype.render = function () {
        return null;
    };
    return ConfirmationPage;
}(React.Component));
/**
 * If user is logged in redirect to the library page
 * if the user is not logged in, render with mutation available.
 */
exports.default = react_router_1.withRouter(ErrorBoundary_1.withDisplayMessage(ConfirmationPage));
var templateObject_1;
